// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeAboutCommittedBuyersPartnerOrganism_wrapper__plG-A"};